import {
  B_03,
  BANNER_DEFAULTS,
  hideB03Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

const FEATURE_FIELDS = {
  icon: {
    type: "imageUrl",
  },
  iconAlt: {
    type: "string",
  },
  text: {
    type: "string",
  },
  video: {
    type: "string",
  },
};

export const B03_PLASMIC_PROPS = {
  b03EyebrowText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_03].eyebrowText,
    description: "Eyebrow text (B03 only)",
    hidden: hideB03Props,
  },
  b03Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_03].heading,
    description: "Main heading (B03 only)",
    hidden: hideB03Props,
  },
  b03Features: {
    type: "array",
    itemType: {
      type: "object",
      fields: FEATURE_FIELDS,
    },
    defaultValue: BANNER_DEFAULTS[B_03].features,
    description: "Features (B03 only)",
    hidden: hideB03Props,
  },
  b03CtaText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_03].ctaText,
    description: "CTA button text (B03 only)",
    hidden: hideB03Props,
  },
  b03CtaLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "CTA button link type (B03 only)",
    hidden: hideB03Props,
  },
  b03CtaOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open CTA button in new tab (B03 only)",
    hidden: hideB03Props,
  },
  b03CtaOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB03Props(props) ||
      (props.b03CtaLinkType !== OTHER_LINK_TYPE && props.b03CtaLinkType !== EXTERNAL_LINK_TYPE),
  },
  b03CtaCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB03Props(props) ||
      (props.b03CtaLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b03CtaLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
